<template>
    <img :src="'../../../static/media/'+language+'.png'" :alt="language">
</template>

<script>
export default {
  name: "ProjectImg",
  props: ["language"],
  data() {
    return {
      languages: []
    };
  },
  methods: {},
  created () {}
};
</script>

<style scoped>
img {
  height: 50px;
  width: 50px;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/ProjectImg.vue